/**
 * Wallet amounts are integer USD cents. Never show fractional cents.
 */
export const formatUsdFromCents = cents => {
  if (cents === null || cents === undefined || cents === '') return '—';
  const n = Number(cents);
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(n / 100);
};

export const formatCredits = value => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return new Intl.NumberFormat('en-US').format(n);
};

/**
 * Mid-cycle seat add-on: unit_price * remaining_seconds / cycle_seconds,
 * rounded to nearest cent, minimum $0.01 when remaining > 0.
 */
export const prorateSeatCents = ({
  unitPriceCents,
  quantity,
  remainingSeconds,
  cycleSeconds,
}) => {
  const unit = Number(unitPriceCents) || 0;
  const qty = Math.max(0, Number(quantity) || 0);
  const remaining = Math.max(0, Number(remainingSeconds) || 0);
  const cycle = Math.max(1, Number(cycleSeconds) || 1);
  if (qty === 0 || remaining === 0 || unit === 0) return 0;

  const raw = (unit * qty * remaining) / cycle;
  return Math.max(1, Math.round(raw));
};

export const canAfford = (balanceCents, amountCents) => {
  const balance = Number(balanceCents) || 0;
  const amount = Number(amountCents) || 0;
  return balance >= amount;
};
